module.exports = __webpack_public_path__ + "img/work-flow.f5d73a04.png";